import React from "react";
import { useSelector } from "react-redux";
import { Card, CardBody, Table } from "reactstrap";
import "./LastDataTab.scss"
import { Divider } from "antd";

const LineLastDataTab = ({ Last_Productions, active_balancer }) => {
  const lang_choiced = useSelector((state) => state.lang_change);

  //   console.log(lastData, "is lastData");
  const checkNullData = (data, date_time, is_serial_number) => {
    // console.log((new Date()).getTime() - 1800000, parseInt(date_time), (((new Date()).getTime() - 1800000)) < parseInt(date_time))
    if ((new Date()).getTime() - 1800000 < parseInt(date_time) && data) return data;
    else if (is_serial_number) return data
    else return "-";
  };
  const getTimeAgoText = (timestamp) => {
    const seconds = Math.floor((Date.now() - parseInt(timestamp)) / 1000);
    if (seconds < 60) return `${seconds} s`;
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes} m`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} h`;
    const days = Math.floor(hours / 24);
    return `${days} day`;
  };
  console.log(active_balancer.Active_Balancer_Data[0], "is active_balancer")
  return (
    <div>
      <Card>
        <CardBody>
          <p>
            {lang_choiced.pages.byPanel.PanelGroup.Line.Modal.tableTab.text}
          </p>
          <div style={{ textAlign: "-webkit-center", overflowX: "auto", width: "100%" }}>
            <Table className="w-auto" style={{ textAlign: "-webkit-center", overflowX: "auto", width: "100%" }} bordered >

              <thead>
                <tr className="table-header">
                  <th>دستگاه</th>
                  <th>{lang_choiced.pages.byPanel.PanelGroup.Line.Modal.seriesName.P}</th>
                  <th>{lang_choiced.pages.byPanel.PanelGroup.Line.Modal.seriesName.Pbat}</th>
                  <th>{lang_choiced.pages.byPanel.PanelGroup.Line.Modal.seriesName.Pnet}</th>
                  <th>{lang_choiced.pages.byPanel.PanelGroup.Line.Modal.seriesName.V}</th>
                  <th>{lang_choiced.pages.byPanel.PanelGroup.Line.Modal.seriesName.I}</th>
                  <th>{lang_choiced.pages.byPanel.PanelGroup.Line.Modal.seriesName.Vbat}</th>
                  <th>{lang_choiced.pages.byPanel.PanelGroup.Line.Modal.seriesName.Ibat}</th>
                  <th>{lang_choiced.pages.byPanel.PanelGroup.Line.Modal.seriesName.Vo}</th>
                  <th>{lang_choiced.pages.byPanel.PanelGroup.Line.Modal.seriesName.SOC}</th>
                  <th>{lang_choiced.pages.byPanel.PanelGroup.Line.Modal.seriesName.Temp}</th>
                  <th>آخرین دریافت</th>
                </tr>
              </thead>
              <tbody>
                {Last_Productions.map((lastData, index) => {
                  return (
                    <tr key={index}>
                      <td className="ltr text-center serial-column">{checkNullData(lastData?.serial_number, lastData?.date_time, true)}</td>
                      <td className="ltr text-center">
                        {checkNullData(((lastData?.Vpv * lastData?.Ipv) / 100000).toFixed(0), lastData.date_time)} W
                      </td>
                      <td className="ltr text-center">
                        {checkNullData(((lastData?.Vbat * lastData?.Ibat) / 100000).toFixed(0), lastData.date_time)} W
                      </td>
                      <td className="ltr text-center">
                        {checkNullData(((lastData?.Vbat * lastData?.Ibat + lastData?.Vpv * lastData?.Ipv) / 100000).toFixed(0), lastData.date_time)} W
                      </td>
                      <td className="ltr text-center">
                        {checkNullData((lastData?.Vpv / 100).toFixed(2), lastData.date_time)} V
                      </td>
                      <td className="ltr text-center">
                        {checkNullData((lastData?.Ipv / 1000).toFixed(2), lastData.date_time)} A
                      </td>
                      <td className="ltr text-center">
                        {checkNullData((lastData?.Vbat / 100).toFixed(2), lastData.date_time)} V
                      </td>
                      <td className="ltr text-center">
                        {checkNullData((lastData?.Ibat / 1000).toFixed(2), lastData.date_time)} A
                      </td>
                      <td className="ltr text-center">
                        {checkNullData((lastData?.Vo / 10).toFixed(1), lastData.date_time)} V
                      </td>
                      <td className="ltr text-center">
                        {checkNullData(Math.min((lastData?.SOC / 100).toFixed(0), 100), lastData.date_time)} %
                      </td>
                      <td className="ltr fs-16 text-center">
                        {checkNullData((lastData?.Temp / 100).toFixed(1), lastData.date_time)} ºC
                      </td>
                      <td className="ltr text-center">
                        {checkNullData(getTimeAgoText(lastData?.date_time), lastData.date_time)}
                      </td>
                    </tr>
                  )
                })}
              </tbody>

            </Table>
          </div>
          {active_balancer && (
            <div>
              <p>اطلاعات دستگاه نول: </p>
              <Divider className="m-0" />
              <div style={{ textAlign: "-webkit-center", overflowX: "auto", width: "100%" }} className="mt-2">
                <Table className="w-auto" style={{ textAlign: "-webkit-center", overflowX: "auto", width: "100%" }} bordered>
                  <thead>
                    <tr className="table-header">
                      <th>دستگاه</th>
                      <th>I<sub>neutral</sub></th>
                      <th>I<sub>neutral rms</sub></th>
                      <th>V<sub>neutral</sub></th>
                      <th className="ltr">V<sub>line+</sub></th>
                      <th className="ltr">V<sub>line-</sub></th>
                      <th>V<sub>line</sub></th>
                      <th>V<sub>earth</sub></th>
                      <th>T<sub>amb</sub></th>
                      <th>T<sub>HS</sub></th>
                      <th>P<sub>neutral</sub></th>
                      <th>آخرین دریافت</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="ltr text-center serial-column">
                        {active_balancer?.serial_number}
                      </td>
                      <td className="ltr text-center">
                        {checkNullData(
                          active_balancer.Active_Balancer_Data[0]?.Ineutral ? (active_balancer.Active_Balancer_Data[0]?.Ineutral / 1000).toFixed(2) : null,
                          active_balancer.Active_Balancer_Data[0]?.date_time
                        )} A
                      </td>
                      <td className="ltr text-center">
                        {checkNullData(
                          active_balancer.Active_Balancer_Data[0]?.Ineutral_rms ? (active_balancer.Active_Balancer_Data[0]?.Ineutral_rms / 1000).toFixed(2) : null,
                          active_balancer.Active_Balancer_Data[0]?.date_time
                        )} A
                      </td>
                      <td className="ltr text-center">
                        {checkNullData(
                          (active_balancer.Active_Balancer_Data[0]?.Vline_pos && active_balancer.Active_Balancer_Data[0]?.Vline_neg) ?
                            ((active_balancer.Active_Balancer_Data[0]?.Vline_pos + active_balancer.Active_Balancer_Data[0]?.Vline_neg) / 10).toFixed(2) : null,
                          active_balancer.Active_Balancer_Data[0]?.date_time
                        )} V
                      </td>
                      <td className="ltr text-center">
                        {checkNullData(
                          active_balancer.Active_Balancer_Data[0]?.Vline_pos ? (active_balancer.Active_Balancer_Data[0]?.Vline_pos / 10).toFixed(2) : null,
                          active_balancer.Active_Balancer_Data[0]?.date_time
                        )} V
                      </td>
                      <td className="ltr text-center">
                        {checkNullData(
                          active_balancer.Active_Balancer_Data[0]?.Vline_neg ? (active_balancer.Active_Balancer_Data[0]?.Vline_neg / 10).toFixed(2) : null,
                          active_balancer.Active_Balancer_Data[0]?.date_time
                        )} V
                      </td>
                      <td className="ltr text-center">
                        {checkNullData(
                          (active_balancer.Active_Balancer_Data[0]?.Vline_pos && active_balancer.Active_Balancer_Data[0]?.Vline_neg) ?
                            ((active_balancer.Active_Balancer_Data[0]?.Vline_pos - active_balancer.Active_Balancer_Data[0]?.Vline_neg) / 10).toFixed(2) : null,
                          active_balancer.Active_Balancer_Data[0]?.date_time
                        )} V
                      </td>
                      <td className="ltr text-center">
                        {checkNullData(
                          active_balancer.Active_Balancer_Data[0]?.Vearth ? (active_balancer.Active_Balancer_Data[0]?.Vearth / 10).toFixed(2) : null,
                          active_balancer.Active_Balancer_Data[0]?.date_time
                        )} V
                      </td>
                      <td className="ltr fs-16 text-center">
                        {checkNullData(
                          active_balancer.Active_Balancer_Data[0]?.Tamb ? (active_balancer.Active_Balancer_Data[0]?.Tamb / 100).toFixed(1) : null,
                          active_balancer.Active_Balancer_Data[0]?.date_time
                        )} ºC
                      </td>
                      <td className="ltr fs-16 text-center">
                        {checkNullData(
                          active_balancer.Active_Balancer_Data[0]?.Ths ? (active_balancer.Active_Balancer_Data[0]?.Ths / 100).toFixed(1) : null,
                          active_balancer.Active_Balancer_Data[0]?.date_time
                        )} ºC
                      </td>
                      <td className="ltr text-center">
                        {checkNullData(
                          // محاسبه P_neutral اگر فرمول مشخصی دارید
                          null,
                          active_balancer.Active_Balancer_Data[0]?.date_time
                        )} W
                      </td>
                      <td className="ltr text-center">
                        {checkNullData(
                          getTimeAgoText(active_balancer.Active_Balancer_Data[0]?.date_time),
                          active_balancer.Active_Balancer_Data[0]?.date_time
                        )}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          )}

        </CardBody>
      </Card>
    </div>
  );
};

export default LineLastDataTab;
